<template>
    <div>
        <router-link :to="path" :title="title" class="l-section__link" />
        <header class="l-section__header">
            <h1 class="l-section__title" :class="[isSingle ? 't-t1-heavy' : 't-t2-heavy']">
                <anim-text :text="title" />
            </h1>
            <div class="l-section__desc">
                <span class="t-link">{{ $t("btn.more") }}</span>
            </div>
        </header>
    </div>
</template>

<script>
import AnimText from "objects/AnimText";

import { routes } from "src/router";
export default {
    components: {
        AnimText
    },
    props: {
        page: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            routes // Add routes to component's data
        };
    },
    computed: {
        target() {
            return this.page ? this.page.type : false;
        },
        route() {
            return this.routes.find(route => route.meta.prismicHandle === this.target);
        },
        isSingle() {
            return !!this.route.meta.single;
        },
        path() {
            return this.isSingle ? this.route.path : this.route.path.replace(":uid", this.page.uid);
        },
        title() {
            return this.isSingle ? this.$store.getters["global/getSinglePushLabel"](this.target) : this.page.data.title;
        }
    }
};
</script>

<style></style>
